import template from './mx-shell-toolbar-navigation--popup.html';

export const mxShellToolbarNavigationPopupComponent = {
	bindings: {
		item: '<',
	},
	controller: MxShellToolbarNavigationPopupController,
	controllerAs: 'vm',
	template: template,
};

MxShellToolbarNavigationPopupController.$inject = ['mx.shell.ToolbarNavigationService'];
function MxShellToolbarNavigationPopupController(toolbarNavigationService) {
	const vm = this;
	vm.toolbarNavigationService = toolbarNavigationService;

	vm.$onInit = function () {
		vm.firstVisibleLevel = toolbarNavigationService.MAX_CHILDREN_LEVEL - vm.item.existLevelsOfChildren + 1;
	};
}
